export default __webpack_public_path__ + "static/media/pg-6.eed6f93c.jpg";